import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropFertilizersOrganicsByPrimaryDataId, getFootprintingCropFertilizersOrganicsByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_FERTILIZERS_ORGANIC } from "consts";

export const useGetFootprintingCropFertilizersOrganic = (primaryDataId: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getFootprintingCropFertilizersOrganicsByPrimaryDataIdAdmin : getFootprintingCropFertilizersOrganicsByPrimaryDataId;
  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP_FERTILIZERS_ORGANIC, primaryDataId],
      queryFn: () => queryFn(primaryDataId),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
